// extracted by mini-css-extract-plugin
export var active = "_cn-7";
export var blink = "_cn-8";
export var dropDownSelector = "_cn-4";
export var dropDownWrapper = "_cn-3";
export var fakeCursor = "_cn-6";
export var fontSizeButton = "_cn-9";
export var formQuillEditor = "_cn-0";
export var pressed = "_cn-a";
export var qlBlank = "_cn-1";
export var textFormattingToolbar = "_cn-2";
export var textToolbarOption = "_cn-5";